export const GET_PROGRESS = 'progressEpic/GET_PROGRESS';
export const GET_PROGRESS_SUCCESS = 'progressEpic/GET_PROGRESS_SUCCESS';
export const GET_PROGRESS_ERROR = 'progressEpic/GET_PROGRESS_ERROR';

export const UPDATE_PROGRESS = 'progressEpic/UPDATE_PROGRESS';

export const FILTER_PROGRESS = 'progressEpic/FILTER_PROGRESS';
